import { BaseButton } from 'components/library/buttons'
import LinkText from 'lang/LinkText'
import Translate from 'lang/Translate'
import TranslateParse from 'lang/TranslateParse'
import { Fragment } from 'react'

const InternalServerError = () => {
  return (
    <Fragment>
      <div className="tile">
        <div className="error-content">
          <div className="mb-4">
            <TranslateParse text="Content.BadGateWay_Content" />
          </div>
          <div>
            <BaseButton fieldId="refresh" labelKey="Buttons.refresh" onClick={() => window.location.reload()} buttonStyles="is-primary refresh-button" />
          </div>
          <div className="mt-5 mb-2">
            <h3><Translate text="Content.pageNotFoundStillGettingError" /></h3>
          </div>
          <div>
            <TranslateParse
              text="Content.InternalServerError_DescribeYourIssue"
              inject={[
                {
                  linkText: "Content.createABlockSignalLink",
                  renderItem: <LinkText to="https://hrbcaprod.service-now.com/hrb/" />
                }
              ]}
            />
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default InternalServerError